module.exports = __webpack_public_path__ + "img/DayUngs.e855edd1.svg";